"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flag = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_jss_1 = require("react-jss");
var flagsSheet = "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";
var flagsCoords = {
    ad: {
        x: -448,
        y: -120,
    },
    ae: {
        x: -448,
        y: -96,
    },
    af: {
        x: -448,
        y: -72,
    },
    ag: {
        x: -448,
        y: -48,
    },
    ai: {
        x: -448,
        y: -24,
    },
    al: {
        x: -448,
        y: 0,
    },
    am: {
        x: -416,
        y: -408,
    },
    ao: {
        x: -384,
        y: -408,
    },
    aq: {
        x: -352,
        y: -408,
    },
    ar: {
        x: -320,
        y: -408,
    },
    as: {
        x: -288,
        y: -408,
    },
    at: {
        x: -256,
        y: -408,
    },
    au: {
        x: -224,
        y: -408,
    },
    aw: {
        x: -192,
        y: -408,
    },
    ax: {
        x: -160,
        y: -408,
    },
    az: {
        x: -128,
        y: -408,
    },
    ba: {
        x: -96,
        y: -408,
    },
    bb: {
        x: -64,
        y: -408,
    },
    bd: {
        x: -32,
        y: -408,
    },
    be: {
        x: 0,
        y: -408,
    },
    bf: {
        x: -416,
        y: -384,
    },
    bg: {
        x: -416,
        y: -360,
    },
    bh: {
        x: -416,
        y: -336,
    },
    bi: {
        x: -416,
        y: -312,
    },
    bj: {
        x: -416,
        y: -288,
    },
    bl: {
        x: -416,
        y: -264,
    },
    bm: {
        x: -416,
        y: -240,
    },
    bn: {
        x: -416,
        y: -216,
    },
    bo: {
        x: -416,
        y: -192,
    },
    bq: {
        x: -416,
        y: -168,
    },
    br: {
        x: -416,
        y: -144,
    },
    bs: {
        x: -416,
        y: -120,
    },
    bt: {
        x: -416,
        y: -96,
    },
    bv: {
        x: -416,
        y: -72,
    },
    bw: {
        x: -416,
        y: -48,
    },
    by: {
        x: -416,
        y: -24,
    },
    bz: {
        x: -416,
        y: 0,
    },
    ca: {
        x: -384,
        y: -384,
    },
    cc: {
        x: -352,
        y: -384,
    },
    cd: {
        x: -320,
        y: -384,
    },
    cf: {
        x: -288,
        y: -384,
    },
    cg: {
        x: -256,
        y: -384,
    },
    ch: {
        x: -224,
        y: -384,
    },
    ci: {
        x: -192,
        y: -384,
    },
    ck: {
        x: -160,
        y: -384,
    },
    cl: {
        x: -128,
        y: -384,
    },
    cm: {
        x: -96,
        y: -384,
    },
    cn: {
        x: -64,
        y: -384,
    },
    co: {
        x: -32,
        y: -384,
    },
    cr: {
        x: 0,
        y: -384,
    },
    cu: {
        x: -384,
        y: -360,
    },
    cv: {
        x: -384,
        y: -336,
    },
    cw: {
        x: -384,
        y: -312,
    },
    cx: {
        x: -384,
        y: -288,
    },
    cy: {
        x: -384,
        y: -264,
    },
    cz: {
        x: -384,
        y: -240,
    },
    de: {
        x: -384,
        y: -216,
    },
    dj: {
        x: -384,
        y: -192,
    },
    dk: {
        x: -384,
        y: -168,
    },
    dm: {
        x: -384,
        y: -144,
    },
    do: {
        x: -384,
        y: -120,
    },
    dz: {
        x: -384,
        y: -96,
    },
    ec: {
        x: -384,
        y: -72,
    },
    ee: {
        x: -384,
        y: -48,
    },
    eg: {
        x: -384,
        y: -24,
    },
    eh: {
        x: -384,
        y: 0,
    },
    er: {
        x: -352,
        y: -360,
    },
    es: {
        x: -256,
        y: -360,
    },
    "es-ca": {
        x: -320,
        y: -360,
    },
    "es-ga": {
        x: -288,
        y: -360,
    },
    et: {
        x: -224,
        y: -360,
    },
    eu: {
        x: -192,
        y: -360,
    },
    fi: {
        x: -160,
        y: -360,
    },
    fj: {
        x: -128,
        y: -360,
    },
    fk: {
        x: -96,
        y: -360,
    },
    fm: {
        x: -64,
        y: -360,
    },
    fo: {
        x: -32,
        y: -360,
    },
    fr: {
        x: 0,
        y: -360,
    },
    ga: {
        x: -352,
        y: -336,
    },
    gb: {
        x: -192,
        y: -336,
    },
    "gb-eng": {
        x: -320,
        y: -336,
    },
    "gb-nir": {
        x: -288,
        y: -336,
    },
    "gb-sct": {
        x: -256,
        y: -336,
    },
    "gb-wls": {
        x: -224,
        y: -336,
    },
    gd: {
        x: -160,
        y: -336,
    },
    ge: {
        x: -128,
        y: -336,
    },
    gf: {
        x: -96,
        y: -336,
    },
    gg: {
        x: -64,
        y: -336,
    },
    gh: {
        x: -32,
        y: -336,
    },
    gi: {
        x: 0,
        y: -336,
    },
    gl: {
        x: -352,
        y: -312,
    },
    gm: {
        x: -352,
        y: -288,
    },
    gn: {
        x: -352,
        y: -264,
    },
    gp: {
        x: -352,
        y: -240,
    },
    gq: {
        x: -352,
        y: -216,
    },
    gr: {
        x: -352,
        y: -192,
    },
    gs: {
        x: -352,
        y: -168,
    },
    gt: {
        x: -352,
        y: -144,
    },
    gu: {
        x: -352,
        y: -120,
    },
    gw: {
        x: -352,
        y: -96,
    },
    gy: {
        x: -352,
        y: -72,
    },
    hk: {
        x: -352,
        y: -48,
    },
    hm: {
        x: -352,
        y: -24,
    },
    hn: {
        x: -352,
        y: 0,
    },
    hr: {
        x: -320,
        y: -312,
    },
    ht: {
        x: -288,
        y: -312,
    },
    hu: {
        x: -256,
        y: -312,
    },
    id: {
        x: -224,
        y: -312,
    },
    ie: {
        x: -192,
        y: -312,
    },
    il: {
        x: -160,
        y: -312,
    },
    im: {
        x: -128,
        y: -312,
    },
    in: {
        x: -96,
        y: -312,
    },
    io: {
        x: -64,
        y: -312,
    },
    iq: {
        x: -32,
        y: -312,
    },
    ir: {
        x: 0,
        y: -312,
    },
    is: {
        x: -320,
        y: -288,
    },
    it: {
        x: -320,
        y: -264,
    },
    je: {
        x: -320,
        y: -240,
    },
    jm: {
        x: -320,
        y: -216,
    },
    jo: {
        x: -320,
        y: -192,
    },
    jp: {
        x: -320,
        y: -168,
    },
    ke: {
        x: -320,
        y: -144,
    },
    kg: {
        x: -320,
        y: -120,
    },
    kh: {
        x: -320,
        y: -96,
    },
    ki: {
        x: -320,
        y: -72,
    },
    km: {
        x: -320,
        y: -48,
    },
    kn: {
        x: -320,
        y: -24,
    },
    kp: {
        x: -320,
        y: 0,
    },
    kr: {
        x: -288,
        y: -288,
    },
    kw: {
        x: -256,
        y: -288,
    },
    ky: {
        x: -224,
        y: -288,
    },
    kz: {
        x: -192,
        y: -288,
    },
    la: {
        x: -160,
        y: -288,
    },
    lb: {
        x: -128,
        y: -288,
    },
    lc: {
        x: -96,
        y: -288,
    },
    li: {
        x: -64,
        y: -288,
    },
    lk: {
        x: -32,
        y: -288,
    },
    lr: {
        x: 0,
        y: -288,
    },
    ls: {
        x: -288,
        y: -264,
    },
    lt: {
        x: -288,
        y: -240,
    },
    lu: {
        x: -288,
        y: -216,
    },
    lv: {
        x: -288,
        y: -192,
    },
    ly: {
        x: -288,
        y: -168,
    },
    ma: {
        x: -288,
        y: -144,
    },
    mc: {
        x: -288,
        y: -120,
    },
    md: {
        x: -288,
        y: -96,
    },
    me: {
        x: -288,
        y: -72,
    },
    mf: {
        x: -288,
        y: -48,
    },
    mg: {
        x: -288,
        y: -24,
    },
    mh: {
        x: -288,
        y: 0,
    },
    mk: {
        x: -256,
        y: -264,
    },
    ml: {
        x: -224,
        y: -264,
    },
    mm: {
        x: -192,
        y: -264,
    },
    mn: {
        x: -160,
        y: -264,
    },
    mo: {
        x: -128,
        y: -264,
    },
    mp: {
        x: -96,
        y: -264,
    },
    mq: {
        x: -64,
        y: -264,
    },
    mr: {
        x: -32,
        y: -264,
    },
    ms: {
        x: 0,
        y: -264,
    },
    mt: {
        x: -256,
        y: -240,
    },
    mu: {
        x: -224,
        y: -240,
    },
    mv: {
        x: -192,
        y: -240,
    },
    mw: {
        x: -160,
        y: -240,
    },
    mx: {
        x: -128,
        y: -240,
    },
    my: {
        x: -96,
        y: -240,
    },
    mz: {
        x: -64,
        y: -240,
    },
    na: {
        x: -32,
        y: -240,
    },
    nc: {
        x: 0,
        y: -240,
    },
    ne: {
        x: -256,
        y: -216,
    },
    nf: {
        x: -256,
        y: -192,
    },
    ng: {
        x: -256,
        y: -168,
    },
    ni: {
        x: -256,
        y: -144,
    },
    nl: {
        x: -256,
        y: -120,
    },
    no: {
        x: -256,
        y: -96,
    },
    np: {
        x: -256,
        y: -72,
    },
    nr: {
        x: -256,
        y: -48,
    },
    nu: {
        x: -256,
        y: -24,
    },
    nz: {
        x: -256,
        y: 0,
    },
    om: {
        x: -224,
        y: -216,
    },
    pa: {
        x: -192,
        y: -216,
    },
    pe: {
        x: -160,
        y: -216,
    },
    pf: {
        x: -128,
        y: -216,
    },
    pg: {
        x: -96,
        y: -216,
    },
    ph: {
        x: -64,
        y: -216,
    },
    pk: {
        x: -32,
        y: -216,
    },
    pl: {
        x: 0,
        y: -216,
    },
    pm: {
        x: -224,
        y: -192,
    },
    pn: {
        x: -224,
        y: -168,
    },
    pr: {
        x: -224,
        y: -144,
    },
    ps: {
        x: -224,
        y: -120,
    },
    pt: {
        x: -224,
        y: -96,
    },
    pw: {
        x: -224,
        y: -72,
    },
    py: {
        x: -224,
        y: -48,
    },
    qa: {
        x: -224,
        y: -24,
    },
    re: {
        x: -224,
        y: 0,
    },
    ro: {
        x: -192,
        y: -192,
    },
    rs: {
        x: -160,
        y: -192,
    },
    ru: {
        x: -128,
        y: -192,
    },
    rw: {
        x: -96,
        y: -192,
    },
    sa: {
        x: -64,
        y: -192,
    },
    sb: {
        x: -32,
        y: -192,
    },
    sc: {
        x: 0,
        y: -192,
    },
    sd: {
        x: -192,
        y: -168,
    },
    se: {
        x: -192,
        y: -144,
    },
    sg: {
        x: -192,
        y: -120,
    },
    sh: {
        x: -192,
        y: -96,
    },
    si: {
        x: -192,
        y: -72,
    },
    sj: {
        x: -192,
        y: -48,
    },
    sk: {
        x: -192,
        y: -24,
    },
    sl: {
        x: -192,
        y: 0,
    },
    sm: {
        x: -160,
        y: -168,
    },
    sn: {
        x: -128,
        y: -168,
    },
    so: {
        x: -96,
        y: -168,
    },
    sr: {
        x: -64,
        y: -168,
    },
    ss: {
        x: -32,
        y: -168,
    },
    st: {
        x: 0,
        y: -168,
    },
    sv: {
        x: -160,
        y: -144,
    },
    sx: {
        x: -128,
        y: -144,
    },
    sy: {
        x: -96,
        y: -144,
    },
    sz: {
        x: -64,
        y: -144,
    },
    tc: {
        x: -32,
        y: -144,
    },
    td: {
        x: 0,
        y: -144,
    },
    tf: {
        x: -160,
        y: -120,
    },
    tg: {
        x: -160,
        y: -96,
    },
    th: {
        x: -160,
        y: -72,
    },
    tj: {
        x: -160,
        y: -48,
    },
    tk: {
        x: -160,
        y: -24,
    },
    tl: {
        x: -160,
        y: 0,
    },
    tm: {
        x: -128,
        y: -120,
    },
    tn: {
        x: -96,
        y: -120,
    },
    to: {
        x: -64,
        y: -120,
    },
    tr: {
        x: -32,
        y: -120,
    },
    tt: {
        x: 0,
        y: -120,
    },
    tv: {
        x: -128,
        y: -96,
    },
    tw: {
        x: -128,
        y: -72,
    },
    tz: {
        x: -128,
        y: -48,
    },
    ua: {
        x: -128,
        y: -24,
    },
    ug: {
        x: -128,
        y: 0,
    },
    um: {
        x: -96,
        y: -96,
    },
    un: {
        x: -64,
        y: -96,
    },
    us: {
        x: -32,
        y: -96,
    },
    uy: {
        x: 0,
        y: -96,
    },
    uz: {
        x: -96,
        y: -72,
    },
    va: {
        x: -96,
        y: -48,
    },
    vc: {
        x: -96,
        y: -24,
    },
    ve: {
        x: -96,
        y: 0,
    },
    vg: {
        x: -64,
        y: -72,
    },
    vi: {
        x: -32,
        y: -72,
    },
    vn: {
        x: 0,
        y: -72,
    },
    vu: {
        x: -64,
        y: -48,
    },
    wf: {
        x: -32,
        y: -48,
    },
    ws: {
        x: 0,
        y: -48,
    },
    xk: {
        x: -64,
        y: -24,
    },
    ye: {
        x: -64,
        y: 0,
    },
    yt: {
        x: -32,
        y: -24,
    },
    za: {
        x: 0,
        y: -24,
    },
    zm: {
        x: -32,
        y: 0,
    },
    zw: {
        x: 0,
        y: 0,
    },
};
var useFlagStyles = (0, react_jss_1.createUseStyles)({
    flag: {
        display: "inline-block",
        backgroundSize: "240px 216px",
        width: "15px",
        height: "11px",
        backgroundImage: "url(\"data:image/png;base64,".concat(flagsSheet, "\")"),
    },
});
var Flag = function (_a) {
    var code = _a.code;
    var classes = useFlagStyles();
    var spriteCoords = flagsCoords[code];
    if (!spriteCoords) {
        return (0, jsx_runtime_1.jsx)("div", {});
    }
    var x = spriteCoords.x, y = spriteCoords.y;
    return (0, jsx_runtime_1.jsx)("div", { className: classes.flag, style: { backgroundPosition: "".concat(x / 2, "px ").concat(y / 2, "px") } });
};
exports.Flag = Flag;
//# sourceMappingURL=Flag.js.map